import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import EventItinerary from '../EventItinerary'
import LocationDates from '../LocationDates'

import './styles.css'

class EventDisplay extends Component {
  static propTypes = {
    tripId: PropTypes.string.isRequired,
    event: PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      depart: PropTypes.string,
      start: PropTypes.bool,
      end: PropTypes.bool,
      arrive: PropTypes.string,
      itinerary: PropTypes.array,
      to: PropTypes.arrayOf(
        PropTypes.shape({
          departureDate: PropTypes.string,
        }).isRequired
      ),
    }).isRequired,
  }

  state = {
    editingItinerary: false,
    editingDates: false,
  }

  toggleEditItinerary = () => {
    this.setState({ editingItinerary: !this.state.editingItinerary, })
  }

  toggleEditDates = () => {
    this.setState({ editingDates: !this.state.editingDates, })
  }

  render() {
    const { editingItinerary, editingDates, } = this.state
    const { tripId, event, } = this.props
    const { name, id, depart, start, end, arrive, itinerary, to, } = event
    const { toggleEditItinerary, toggleEditDates, } = this

    let itineraryBtnLabel = 'Edit itinerary'
    if (!itinerary || (itinerary && itinerary.length === 0)) {
      itineraryBtnLabel = 'Add itinerary'
    }
    if (editingItinerary) {
      itineraryBtnLabel = 'Cancel'
    }
    let itineraryBtn = <button onClick={toggleEditItinerary}>{itineraryBtnLabel}</button>

    let itineraryEditorDisplay
    if (editingItinerary) {
      itineraryEditorDisplay = (<EventItinerary
        tripId={tripId}
        locationId={id}
        itinerary={itinerary}
        fromDate={arrive}
        toDate={to[0].departureDate}
        to={to}
      />)
    }

    let dateEditorDisplay
    if (editingDates) {
      dateEditorDisplay = (
        <LocationDates
          tripId={tripId}
          locationId={id}
        />
      )
    }
    let datesBtnLabel = 'Edit Date'
    if (editingDates) {
      datesBtnLabel = 'Cancel'
    }
    const datesBtn = <button onClick={toggleEditDates}>{datesBtnLabel}</button>

    if (start || end || !to || !to.length) {
      itineraryBtn = undefined
    }
    const descr = (start) ? depart : arrive
    return (
      <div key={id} className="EditTrip-EventDisplay">
        <div>{name} ({descr}) {itineraryBtn} {datesBtn}</div>
        {itineraryEditorDisplay}
        {dateEditorDisplay}
      </div>
    )
  }
}

export default EventDisplay



// WEBPACK FOOTER //
// ./src/components/EditTrip/EventDisplay/index.js